//@flow
import React from "react"
import {observer} from "mobx-react"
import {FormattedMessage} from "react-intl"

import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import DialogActions from "@material-ui/core/DialogActions"
import XsButton from "../../../../../global/ui/xsButton/xsButton"
import renderHTML from "react-render-html"
import DoctorOUPZwarningDialogStore from "../../../stores/DoctorOUPZwarningDialogStore"

@observer
export default class DoctorOUPZwarningDialog extends React.Component {
	constructor(props) {
		super(props)
	}

	render() {
		return (
			<Dialog
				id="xsDoctorOUPZWarningDialog"
				open={DoctorOUPZwarningDialogStore.isOpen}
				onClose={() => DoctorOUPZwarningDialogStore.close()}
				disableBackdropClick={true}
				maxWidth="md"
				className="xs-base-dialog"
			>
				<DialogTitle className="xs-warning">
					<div className="xs-header">
						<div className="xs-header-icon">
							<i className="fal fa-exclamation-triangle fa-2x"></i>
						</div>
						<div className="xs-header-title">
							<FormattedMessage id="Common.label.warning" />
						</div>
					</div>
				</DialogTitle>
				<DialogContent className="xs-content">
					{isEmpty(DoctorOUPZwarningDialogStore.warning) ? "" : renderHTML(DoctorOUPZwarningDialogStore.warning)}
				</DialogContent>
				<DialogActions className="xs-footer">
					<XsButton
						className="xs-warning"
						icon={<i className="fal fa-times"></i>}
						text={<FormattedMessage id="Common.label.ok" />}
						onClick={() => DoctorOUPZwarningDialogStore.close()}
					/>
				</DialogActions>
			</Dialog>
		)
	}
}
